function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.669 0C18.07 0 19.99 1.929 20 5.33V14.67C20 18.07 18.07 20 14.669 20H5.33C1.929 20 0 18.07 0 14.67V5.33C0 1.929 1.929 0 5.33 0H14.669ZM11.7135 15.25C11.7135 16.2166 10.9461 17 10 17C9.05393 17 8.28652 16.2166 8.28652 15.25H11.7135ZM15.6681 12.7969C15.7033 12.8347 15.7372 12.8711 15.7694 12.9064C15.9301 13.0825 16.0013 13.2936 16 13.5C15.9973 13.9484 15.6523 14.375 15.1402 14.375H4.85984C4.3477 14.375 4.00296 13.9484 4.00002 13.5C3.99868 13.2936 4.06993 13.0827 4.23064 12.9064C4.26279 12.8711 4.29667 12.8347 4.33195 12.7969C4.86469 12.2251 5.71644 11.311 5.71644 8.6875C5.71644 6.56289 7.17572 4.86211 9.1434 4.44484V3.875C9.1434 3.39184 9.52697 3 10 3C10.473 3 10.8566 3.39184 10.8566 3.875V4.44484C12.8243 4.86211 14.2836 6.56289 14.2836 8.6875C14.2836 11.311 15.1353 12.2251 15.6681 12.7969Z",
  fill: "white"
});

var SvgIconNotification = function SvgIconNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_notification.f0953ff1.svg";
export { ForwardRef as ReactComponent };